module.exports = __webpack_public_path__ + "img/kv_img_6.8ec29058.png";